import React from 'react'
import { Button, CardBody, Col, Label, Row } from 'reactstrap';
import { Address, CompanyName, Email, GSTTax, MobileNo, Next } from '../../../Constant';
import { Controller } from 'react-hook-form';
import PhoneInput from 'react-phone-input-2';

const CompanyForm = ({register,control}) => {
  return (
    <CardBody>
    <Row className="g-3">
        <Col sm="12" md="6">
            <Label>{CompanyName} <span className="requireStar">*</span></Label>
            <input className="form-control" type="text" {...register("name")} />
            {/* <span className="text-danger pt-2">{errors.name && errors.name.message}</span> */}
        </Col>
        <Col md="6">
            <Label htmlFor="email">{Email} <span className="requireStar">*</span></Label>
            <input className="form-control" type="text" name="email" {...register("email")} />
            {/* <span className="text-danger">{errors.email && errors.email.message}</span> */}
        </Col>
    </Row>
    <Row className="g-3 pt-3">
        <Col md="6">
            <Label htmlFor="gst">{GSTTax}</Label>
            <input className="form-control" type="text" name="taxin" {...register("taxin")} />
            {/* <span className="text-danger">{errors.taxin && errors.taxin.message}</span> */}
        </Col>
        <Col md="6">
            <Label className="form-label" >{MobileNo} <span className="requireStar">*</span></Label>
            <Controller
                name="phone"
                control={control}
                defaultValue=""
                render={({ field }) => (
                    <PhoneInput
                        {...field}
                        country={"bn"}
                        enableSearch={true}
                        onChange={(value, country) => {
                            setValue("countryCode", country.dialCode);
                            field.onChange(value);
                        }}
                        inputStyle={{
                            width: "100%",
                            height: "46px",
                            padding: "10px",
                            paddingLeft: "50px",
                            fontSize: "16px",
                            borderRadius: "8px",
                            borderColor: "rgba(83, 70, 134, 0.1019607843)",
                        }}
                        searchClass="none"
                    />
                )}
            />
            {/* <span className="text-danger">{errors.phone && errors.phone.message}</span> */}
        </Col>
    </Row>
    <Row className="g-3 pt-3">
        <Col md="6">
            <Label htmlFor="address">{Address}</Label>
            <textarea className="form-control" type="text" {...register("address")} />
        </Col>
        <Col md="6">
            <Label className="form-label">Logo</Label>
            <Controller
                name="logo"
                control={control}
                render={({ field }) => (
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                        }}
                    >
                        <Col md="8">
                            <input
                                {...register("logo")}
                                className="form-control fileInputStyle"
                                type="file"
                                // onChange={handleLogoChange}
                                accept=".png, .jpg, .jpeg"
                            />
                        </Col>
                        <Col md="4">
                            <span className="imagestyle">
                                <img
                                // {logo && <img
                                    // src={window.URL.createObjectURL(logo)}
                                    alt="logo"
                                    width="40px"
                                    height="40px"
                                />
                                
                                {/* } */}
                            </span>
                        </Col>
                    </div>
                )}
            />
        </Col>
        <div className="text-end  ">
            <Button className="tab-button" >{Next}</Button>
            {/* <Button className="tab-button" onClick={nextTab}>{Next}</Button> */}
        </div>
    </Row>
</CardBody>

  )
}

export default CompanyForm